export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14482.27e125dd.jpg";